export default __webpack_public_path__ + "static/media/icons8-group-90.358ed0f3.svg";